export default ({
    previous,
    current,
    next,
    part,
    repeater,
    repeaterId,
    dependData,
    optional,
    answers,
    sections,
    currentSectionId,
}) => {
    let previousHref = previous && `${part.slug}/${previous.slug}`;
    let nextHref = next && `${part.slug}/${next.slug}`;

    if (repeater && dependData) {
        previousHref = `${part.slug}/${current.slug}/${+repeaterId - 1}`;
        nextHref = `${part.slug}/${current.slug}/${+repeaterId + 1}`;

        if (dependData.length - 1 === +repeaterId) {
            nextHref = `${part.slug}/${next.slug}`;
        }

        if (+repeaterId === 0) {
            previousHref = previous && `${part.slug}/${previous.slug}`;
        }
    }

    if (next && next.repeater) {
        nextHref += '/0';
    }
    if (previous && previous.repeater) {
        previousHref += '/0';
    }

    // if some questions are optional -> get the url of the first following non optional questions
    const stopSkip = sections.slice(currentSectionId)
        .find(s => s.optional !== true);
    const skipHref = `${part.slug}/${stopSkip.slug}`;

    let returnSkipUrl;

    if (answers[part.slug] && part.hasOptionalQuestions) {
        const returnSkipSection =
            sections.find(s => answers[part.slug]
                && !answers[part.slug][s.slug]);
        returnSkipUrl = `${part.slug}/${returnSkipSection.slug}`;
    }

    return {
        previousHref: (returnSkipUrl && !optional)
            ? returnSkipUrl
            : previousHref,
        nextHref,
        skipHref,
    };
};



// WEBPACK FOOTER //
// ./src/utils/getHrefs.js